const moveFlipbookButtons = () => {
    const body = document.body;

    if (body.classList.contains('uberflip')) {
        const controls = body.querySelector('.fullscreen-controls.underneath');
        const embedWrapper = body.querySelector('.single-uberflip');
        if (controls && embedWrapper) {
            embedWrapper.insertAdjacentElement('afterbegin', controls);
        }
    }
};

const flipbook = () => {
    moveFlipbookButtons();
};

module.exports = flipbook;


// WEBPACK FOOTER //
// ./scriptPartials/flipbook.js